var _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviousIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6233 27.1862C28.6233 28.8604 28.6233 29.6975 28.2801 30.1274C27.9816 30.5014 27.529 30.7189 27.0506 30.7184C26.5005 30.7178 25.8468 30.1948 24.5394 29.149L15.3667 21.8108C14.528 21.1398 14.1087 20.8044 13.9569 20.3991C13.8238 20.0437 13.8238 19.6522 13.9569 19.2969C14.1087 18.8916 14.528 18.5561 15.3667 17.8852L24.5394 10.547C25.8468 9.50111 26.5005 8.97817 27.0506 8.97757C27.529 8.97706 27.9816 9.19459 28.2801 9.56851C28.6233 9.99846 28.6233 10.8356 28.6233 12.5098L28.6233 27.1862Z",
    stroke: "white",
    strokeWidth: 2.07059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6152 27.1865C22.6152 28.8608 22.6152 29.6979 22.272 30.1278C21.9736 30.5017 21.521 30.7193 21.0425 30.7187C20.4924 30.7182 19.8387 30.1952 18.5314 29.1493L9.35864 21.8112C8.51997 21.1402 8.10063 20.8047 7.94881 20.3995C7.81569 20.0441 7.81569 19.6526 7.94881 19.2972C8.10063 18.892 8.51997 18.5565 9.35864 17.8855L18.5314 10.5474C19.8387 9.50148 20.4924 8.97854 21.0425 8.97794C21.521 8.97743 21.9736 9.19496 22.272 9.56888C22.6152 9.99883 22.6152 10.8359 22.6152 12.5102L22.6152 27.1865Z",
    stroke: "white",
    strokeWidth: 2.07059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 1.7057,
    y: 1.73061,
    width: 34.1647,
    height: 36.2353,
    rx: 5.17647,
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2.07059
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousIcon);
export default __webpack_public_path__ + "static/media/previous_icon.23213ac1.svg";
export { ForwardRef as ReactComponent };